module.exports = __webpack_public_path__ + "img/casestudies_icon.bde0a7ef.svg";